import axios from 'axios';

async function getCitiesByZipcode(zipcode) {
    const response = await axios.get(`/cities?zipcode=${zipcode}`);

    return response.data;
}

const cityService = {
    getCitiesByZipcode
}

export default cityService;